import React from 'react';
import { StartBotPromoterPanel } from '../../../startBotPromoters/common/StartBotPromoterPanel/StartBotPromoterPanel';
import { PromotersType } from '../../PromotersPanel/use-prime-state';

const kind: PromotersType = 'optin';
export const LeadsPromoterPanel = () => <StartBotPromoterPanel kind={kind} />;
